const LOCK_IN_RATE_PATH = '/lock-in-rate';
const CONTACT_US_PATH = '/contact-us';

export {
  LOCK_IN_RATE_PATH,
  CONTACT_US_PATH,
};
